const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type TalentSearchFilters = {
  query?: string;
  location?: string;
  returnerFriendly?: boolean;
  minExperience?: number;
  skills?: string[];
  occupationId?: string;
};

export type TalentSearchResult = {
  id: string;
  name: string;
  title: string;
  location: string;
  experienceYears: number;
  skills: string[];
  matchScore: number;
  availability: string;
  salaryRange: string;
  returner: boolean;
  bio: string;
};

export async function searchTalent(filters: TalentSearchFilters): Promise<TalentSearchResult[]> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to search talent.');
  }

  const params = new URLSearchParams();
  if (filters.query) params.set('query', filters.query);
  if (filters.location) params.set('location', filters.location);
  if (filters.returnerFriendly) params.set('returnerFriendly', 'true');
  if (typeof filters.minExperience === 'number') params.set('minExperience', String(filters.minExperience));
  if (filters.skills?.length) params.set('skills', filters.skills.join(','));
  if (filters.occupationId) params.set('occupationId', filters.occupationId);

  const response = await fetch(`${API_BASE_URL}/v1/candidates/search?${params.toString()}`, {
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const errorText = await response.text().catch(() => 'request failed');
    throw new Error(`Talent search failed (${response.status}): ${errorText}`);
  }
  const payload = await response.json();
  if (Array.isArray(payload?.results)) {
    return payload.results as TalentSearchResult[];
  }
  return [];
}
